import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { SiteFooterLayout, SiteHeaderLayout, SiteHeaderProvider, ExplorerViewLayout} from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
const cls = classNames('page-layout-explorer');

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;

  `,
});

const LayoutStyles = breakpoints({
  base: css`

    .shp--slice-layout-content-with-image {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 2em;
          font-weight: 500;
          margin-bottom: ${theme.UNIT(8)};
        }
      }
      .shp--slice-block-image__layout {
        img {
          width: 100%;
        }
      }
    }
  `,
  tablet: css`
    .shp--slice-layout-content-with-image {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 2.8em;
        }
      }
    }
  `,
  desktop: css`
    .shp--slice-layout-content-with-image {
      .shp--content-entity-block {
        .shp--content-entity-block__title {
          font-size: 4em;
        }
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(6)};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `
});


// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerViewLayout)`${LayoutStyles}`,
    Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const PageLayoutExplorer: PageLayoutComponent = (props) => {
  const { className, entity } = props;

  return (
    <SiteHeaderProvider
      value={{
        variant: 'default', // setting variant to overlay keeps the login utility button icon and text white...
        boundary: 'content'
      }}>
      <My.Container className={cls.name(className)}>
        <My.Header />
        <My.Layout 
          defaultView='home'
          entity={entity} 
          // showSiteFooter={(activeView) => activeView !== 'home'} 
          />
      </My.Container>
    </SiteHeaderProvider>
  )
};